var map = {
	"./bonus-dice-1-x-win.png": 637,
	"./bonus-dice-2-x-win.png": 638,
	"./bonus-dice-3-x-win.png": 639,
	"./bonus-dice-4-x-win.png": 640,
	"./bonus-dice-5-x-win.png": 641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;